import { GenericAbortSignal } from 'axios';

import http from 'services/http';

// A client's portal mappings: per-(client, source system) named bags of external
// portal string -> mapped value. `facility` is the bag in use (mapped value = a
// provider group id); other names can piggyback without schema changes.

export const FACILITY_MAPPING_NAME = 'facility';

export interface PortalMappingOptions {
  id: string;
  clientId: string;
  sourceSystem: string;
  name: string;
  externalValue: string;
  // A group id for `facility` mappings; shape depends on the mapping name.
  mappedValue: string;
  // Display text for the mapped value (the facility's name), resolved server-side.
  mappedLabel: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PortalMappingsIndex {
  data: PortalMappingOptions[];
}

export const portalMappingQueryKeys = {
  base: ['portalMappings'] as const,
  list: (clientId: string) => ['portalMappings', 'list', clientId] as const,
};

export async function indexPortalMappings(clientId: string, signal?: GenericAbortSignal) {
  return http
    .get<PortalMappingsIndex>(`admin/portal_mappings`, { params: { client_id: clientId }, signal })
    .then((res) => res.data);
}

export type UpsertPortalMappingInput = {
  // Top-level field keys are camelCase; OliveBranch snake_cases them on the API.
  clientId: string;
  sourceSystem: string;
  name: string;
  externalValue: string;
  mappedValue: string;
};

export async function upsertPortalMapping(input: UpsertPortalMappingInput) {
  return http.post<PortalMappingOptions>(`admin/portal_mappings`, input).then((res) => res.data);
}

export async function deletePortalMapping(id: string, clientId: string) {
  return http.delete(`admin/portal_mappings/${id}`, { params: { client_id: clientId } });
}
